import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron right small.svg` */
export const ChevronRightSmallIcon = createTripletGlyphIcon('ChevronRightSmallIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.83987 12.4023C5.60446 12.5938 5.25826 12.5584 5.06643 12.3232C4.87456 12.0877 4.91005 11.7407 5.14553 11.5488L9.66311 7.86909L5.16116 4.46284C4.91896 4.27959 4.87056 3.93456 5.05374 3.69233C5.237 3.45011 5.58201 3.40265 5.82424 3.58589L10.8106 7.35835C11.1323 7.60175 11.1409 8.08204 10.8281 8.33686L5.83987 12.4023Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.90705 15.1471C5.60742 15.3908 5.16678 15.3459 4.92268 15.0465C4.67873 14.7468 4.72378 14.3053 5.02327 14.0611L11.4656 8.81309L5.0428 3.95372C4.73481 3.72046 4.67405 3.28145 4.90705 2.97325C5.14025 2.66504 5.57924 2.60448 5.88752 2.83751L12.9168 8.15587C13.3313 8.46953 13.3423 9.08825 12.9393 9.41661L5.90705 15.1471Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.89891 20.1701C7.5137 20.484 6.94635 20.4262 6.63231 20.0412C6.31849 19.656 6.37623 19.0896 6.76122 18.7756L11.0727 15.2629L15.3843 11.7502L6.78661 5.24529C6.39056 4.94534 6.31208 4.38081 6.6118 3.98454C6.91159 3.58832 7.47619 3.51025 7.87255 3.80974L17.2456 10.9015C17.7806 11.3068 17.7952 12.1064 17.2749 12.5304L7.89891 20.1701Z"
        fill="currentColor"
      />
    </svg>
  ),
});
